<template>
  <!-- component -->
  <div class="h-screen">
    <div class="flex justify-center py-3 items-center bg-g0 text-white px-2">
      <form
        class="mx-4 mx-auto"
        @submit.prevent="$emit('login')"
        v-if="!config.lost"
      >
        <!-- <div v-html="LogoForm"></div> -->

        <!-- ERROR -->
        <div
          v-if="config.error != false"
          class="text-sm text-red-500 mt-7 lg:max-w-md"
        >
          {{ $e(config.error) }}
        </div>
        <!-- END -->

        <div class="flex flex-row">
          <div
            class="flex items-center border-2 py-2 px-3 rounded-2xl mb-4 mt-7 bg-g1 mr-2"
          >
            <label for="email">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
                />
              </svg>
            </label>
            <input
              class="ml-2 pl-2 outline-none border-none w-full !bg-transparent placeholder:text-g3"
              v-model="config.email"
              type="text"
              name="email"
              id=""
              placeholder="Email"
              autocomplete="email"
              required
              @focus="config.error = false"
            />
          </div>

          <div
            class="flex items-center border-2 py-2 px-3 rounded-2xl mb-4 mt-7 bg-g1 mx-2"
          >
            <label for="password">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                class="h-5 w-5 text-white"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fill-rule="evenodd"
                  d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
                  clip-rule="evenodd"
                />
              </svg>
            </label>
            <input
              class="ml-2 pl-2 outline-none border-none w-full !bg-transparent placeholder:text-g3"
              type="password"
              name="password"
              id="password"
              placeholder="Mot de passe"
              autocomplete="password"
              v-model="config.password"
              required
              @focus="config.error = false"
            />
          </div>
        </div>

        <span
          class="block text-sm mt-3 text-g3 hover:text-flyingeye-light cursor-pointer"
          @click.prevent="config.lost = true"
        >
          Mot de passe oublié ?
        </span>
        <button
          type="submit"
          class="block w-full bg-flyingeye mt-5 py-2 rounded-2xl text-white font-semibold mb-2 flex items-center justify-center"
          :class="{
            'bg-g2 opacity-40 cursor-not-allowed':
              config.email == '' || config.password == '',
          }"
          :disabled="config.email == '' || config.password == ''"
        >
          Connexion

          <svg
            v-if="config.load"
            class="float-right animate-spin ml-3 w-[18px] text-white"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
          >
            <circle
              class="opacity-25"
              cx="12"
              cy="12"
              r="10"
              stroke="currentColor"
              stroke-width="4"
            ></circle>
            <path
              class="opacity-75"
              fill="currentColor"
              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
            ></path>
          </svg>
        </button>
      </form>

      <form
        class="mx-10 mx-auto"
        @submit.prevent="$emit('resetPassword')"
        v-else
      >
        <!-- <div v-html="LogoForm"></div> -->

        <p class="mt-7">Mot de passe oublié ?</p>
        <div
          class="flex items-center border-2 py-2 px-3 rounded-2xl mb-4 mt-2 bg-g1"
        >
          <label for="email">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-5 w-5 text-white"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M16 12a4 4 0 10-8 0 4 4 0 008 0zm0 0v1.5a2.5 2.5 0 005 0V12a9 9 0 10-9 9m4.5-1.206a8.959 8.959 0 01-4.5 1.207"
              />
            </svg>
          </label>
          <input
            class="ml-2 pl-2 outline-none border-none w-full !bg-transparent placeholder:text-g3"
            type="text"
            name="email"
            id="email"
            placeholder="Email"
            autocomplete="email"
            v-model="config.email"
            required
          />
        </div>
        <button
          type="submit"
          class="block w-full bg-flyingeye mt-5 py-2 rounded-2xl text-white font-semibold mb-2"
          :class="{ 'bg-g2': config.email == '' }"
          :disabled="config.email == ''"
        >
          Récupérer mon mot de passe
        </button>
        <span
          class="block text-sm mt-5 text-g3 hover:text-flyingeye-light cursor-pointer"
          @click.prevent="config.lost = false"
        >
          Retour
        </span>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: "DJI_RC_PRO_E",
  props: {
    config: {
      type: Object,
      default: () => ({
        email: "",
        password: "",
        error: false,
        load: false,
        lost: false,
      }),
    },
  },
};
</script>
